import { isEqual } from "lodash";
import { usePrevious } from "../hooks";
import { useDeepCompareEffectNoCheck } from "use-deep-compare-effect";
import { useContext, useEffect } from "react";
import { GrigoraDashboardContext } from "../dashboard/context";

let statuses = {
  inactive: "inactive",
  active: "active",
  loading: "loading",
};

const noop = () => {};

function CustomFontLoader({ onStatus = noop, children, context }) {
  const { project } = useContext(GrigoraDashboardContext);
  const customFonts = project?.customFonts ?? [];
  const prevFonts = usePrevious(customFonts);

  useDeepCompareEffectNoCheck(() => {
    if (!isEqual(prevFonts, customFonts) && customFonts.length > 0) {
      onStatus(statuses.loading);

      // Create style element for custom fonts
      const styleEl = document.createElement("style");
      styleEl.id = "grigora-custom-fonts";

      // Generate @font-face declarations
      const fontFaces = customFonts
        .map(
          (font) => `
        @font-face {
          font-family: "${font.family}";
          src: url("https://cdn.grigora.co/${
            font.file
          }") format("${getFontFormat(font.originalName)}");
          font-weight: ${font.weight};
          font-style: ${font.style};
          font-display: ${font.display};
        }
      `,
        )
        .join("\n");

      styleEl.textContent = fontFaces;

      // Get the target document context
      const targetDocument =
        context?.document ||
        window?.frames["iframe-renderer"]?.contentDocument ||
        document;

      console.log(targetDocument);

      // Remove any existing custom font styles
      const existingStyle = targetDocument.getElementById(
        "grigora-custom-fonts",
      );
      if (existingStyle) {
        existingStyle.remove();
      }

      // Add new styles to the appropriate context
      targetDocument.head.appendChild(styleEl);
      onStatus(statuses.active);
    }
  }, [customFonts, context]);

  return children || null;
}

// Helper function to determine font format from filename
function getFontFormat(filename) {
  const ext = filename.split(".").pop().toLowerCase();
  switch (ext) {
    case "woff2":
      return "woff2";
    case "woff":
      return "woff";
    case "ttf":
      return "truetype";
    case "otf":
      return "opentype";
    default:
      return "truetype";
  }
}

export default CustomFontLoader;
